import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { setToken } from "@/utils";
import { useAppDispatch } from "@/utils/redux";
import { DashboardRoutes } from "@/router/constant";
import { useAtom } from "jotai";
import { dashboardPreferencesAtom } from "@/core/state";
import { selectAtom } from "jotai/utils";

const urlForLoginRedirectAtom = selectAtom(dashboardPreferencesAtom, (val) => val.urlForLoginRedirect);

const OAuthCallbackPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [urlForLoginRedirect] = useAtom(urlForLoginRedirectAtom);

  useEffect(() => {
    const token = location.hash.split("access_token=")[1]?.split("&")[0];
    if (token) {
      setToken.forAll(dispatch, token);
      if (urlForLoginRedirect) {
        navigate(urlForLoginRedirect);
        return;
      }
      navigate(DashboardRoutes.home.root.url);
    }
    // userManager
    //   .signinRedirectCallback()
    //   .then((res) => {
    //     if (res) {
    //       setToken.forAll(dispatch, res.access_token);
    //       if (urlForLoginRedirect) {
    //         navigate(urlForLoginRedirect);
    //         return;
    //       }
    //       navigate(DashboardRoutes.home.root.url);
    //     }
    //   })
    //   .catch(() => {
    //     // navigate(DashboardRoutes.login.url)
    //   });
  }, [dispatch, navigate, urlForLoginRedirect, location.hash]);

  return <Navigate to={DashboardRoutes.home.root.url} />;
};

export default OAuthCallbackPage;
